<template>
    <div id="pharmacy-location-container">
        <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">{{$t('PharmacyLocations.AddTitle')}}</h4>
        <h4 v-else class="page-title text-truncate">{{$t('PharmacyLocations.EditTitle')}}</h4>

        <div class="page-height">
            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                <div class="flex-grow-1">
                    <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                </div>
            </div>

            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('Shared.Code')"
                        v-bind:Name="'Code'"
                        v-bind:TypeProp="'text'"  
                        v-bind:MaxLengthProp="20"     
                        v-model="editableItem.code"
                        v-bind:isReadOnly="isReadOnly || this.$attrs.editMode"
                        v-bind:Id="'input_code'"
                        v-bind:isRequired="true"
                        v-bind:isValid="isCodeValid"
                    />
                </b-col>
         
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('Shared.Description')"
                        v-bind:Name="'Description'"
                        v-bind:TypeProp="'text'"  
                        v-bind:MaxLengthProp="250"         
                        v-model="editableItem.name"
                        v-bind:isReadOnly="isReadOnly"
                        v-bind:Id="'input_description'"
                        v-bind:isRequired="true"
                        v-bind:isValid="isDescriptionValid"
                    /> 
                </b-col>         
                <b-col lg="3" md="3" sm="12" class="mt-1">
                    <MdSelect 
                        v-bind:Label="'Branch Location'"
                        v-bind:Options="BranchLocationList"
                        v-bind:FieldDescription="'description'" 
                        v-bind:FieldCode="'code'"
                        v-bind:Model="BranchLocationModel" 
                        v-bind:isValid="this.isBranchLocationValid"
                        v-bind:AllowEmpty="true" 
                        v-bind:Multiple="false"
                        :IsDisabled="isReadOnly" 
                        :Input="ChangeDropDownBranchLocation" 
                    />
                </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdCheckBox
                        v-bind:Label="$t('PharmacyLocations.ShowInItemsRelocation')"
                        v-bind:Name="'showInItemsRelocation'"
                        v-bind:ClassProp="'AlignCheck  mt-2'"
                        v-bind:CheckedValue="'Y'"
                        v-bind:UncheckedValue="'N'"
                        v-model="editableItem.showInItemsRelocation"/>
                </b-col>
            </b-row>

          
               
          

            <b-row>
                <b-col lg="6" md="6" sm="12">
                    <MdCheckBox
                        v-bind:Label="$t('PharmacyLocations.DefaultRelocationLocation')"
                        v-bind:Name="'defaultRelocationLocation'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="'Y'"
                        v-bind:UncheckedValue="'N'"
                        v-model="editableItem.defaultRelocationLocation"/>
                </b-col>
            </b-row>
        </div>

        <div class="space-actions"></div>        
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btn_pharmacy_location_list'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="discardChanges"/>
        
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="isReadOnly ? 'primary mx-2':'primary btn-login mx-2'"
                v-on:click="saveOrEdit"
                v-bind:isReadOnly="!saveButtonEnabled"
                v-bind:Name="'btn_save_pharmacy_locations'"/>
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import ePharmacyLocationsService from '@/services/epharmacylocation.service';
import BranchLocation from '@/services/branchlocation.service'
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'PharmacyLocations',
    mixins: [ShowMessage, DBFunctions],

    data() {
        return {
            isReadOnly: false,
            editableItem: {
                code: null,
                defaultRelocationLocation: null,
                location: null,
                name: null,
                showInItemsRelocation: null,
            },
            isCodeValid: true,
            isDescriptionValid: true,
            isBranchLocationValid: true,
            BranchLocationList: [],
            BranchLocationModel:{code:"",description:""},
            pendingChanges: false,
            OffRoute: false,
            WasSaved: false,
        }
    },

    computed: {
        saveButtonEnabled() {
            const isCodeValid = !Utils.isNullOrEmptyString(this.editableItem.code);
            const isDescriptionValid = !Utils.isNullOrEmptyString(this.editableItem.name);
            const isEnabled = !this.isReadOnly && this.pendingChanges && isCodeValid && isDescriptionValid;
            return isEnabled;
        }
    },

    methods: {
        discardChanges() {
            this.$router.push({ name: "PharmacyLocationsSetupList"});
        },

        async saveOrEdit() {
            if(this.validate_required()){
                if(this.$attrs.editMode){
                    await this.update();
                } else {
                    await this.insert();
                }
            } else {
                this.OffRoute = false;
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.CheckRedLabeledFields'),"errorAutoHide");
            }
        },

        async insert() {
            await ePharmacyLocationsService
                .Add(this.editableItem)
                .then((response) => {
                    if (response.status == '200') {
                        this.WasSaved = true;
                        this.pendingChanges = false;

                        if(!this.OffRoute) {
                            this.discardChanges();
                        }

                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            }
                        ), 50);
                    }
                })
                .catch((error) => {
                    this.OffRoute = false;
                    this.showResponseErrorMessage(error);
                });
        },

        async update() {
            await ePharmacyLocationsService
                .Update(this.$route.params.id, this.editableItem)
                .then((response) => {
                    if (response.status == '200') {
                        this.WasSaved = true;
                        this.pendingChanges = false;

                        if(!this.OffRoute) {
                         this.discardChanges();
                        }

                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            }
                        ), 50);
                    }
                })
                .catch((error) => {
                    this.OffRoute = false;
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            this.isCodeValid = !Utils.isNullOrEmptyString(this.editableItem.code);
            this.isDescriptionValid = !Utils.isNullOrEmptyString(this.editableItem.name);

            return this.isCodeValid && this.isDescriptionValid;
        },

        ChangeDropDownBranchLocation(item){              
            this.BranchLocationModel =  item ? item : {code:"",description:""};              
            this.editableItem.location = this.BranchLocationModel.code;
        },

        getPharmacyLocation() {
            ePharmacyLocationsService
                .Get(this.$route.params.id)
                .then((response) => {
                    if(response.status == '200' && response.data){                
                        this.editableItem = response.data;
                        
                        this.BranchLocationModel.code = this.editableItem.location;
                        const branch = this.BranchLocationList.find(x => x.code === this.editableItem.location);
                        if (branch) {
                            this.BranchLocationModel.description = branch.description;
                        }
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        async onLoad() {
            if(this.$store.state.branchlocationwasloaded){
                this.BranchLocationList = [
                    {code: '<ALL>', description: '<ALL>'},
                    ...this.$store.state.branchlocationsList
                ];
            }else{
                await BranchLocation.GetBranchLocations()
                        .then((response) => {
                            if(response.status == '200'){
                                this.BranchLocationList = [
                                    {code: '<ALL>', description: '<ALL>'},
                                    ...response.data
                                ];                     
                                this.$store.commit('initBranchLocationList')
                                this.$store.commit('setBranchLocationwasloaded',true);  
                                response.data.forEach(element => {
                                    this.$store.commit('setBranchLocationList',element);
                                });
                            }
                        })          
                        .catch((error) => {
                            this.showResponseErrorMessage(error);
                        });   
            } 
        },

        async ClickOffRoute() {
            this.OffRoute = true;       
            await this.saveOrEdit();
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault()
                e.returnValue = ''	
            }
        },
    },

    async mounted() {
        await this.onLoad();

        if(this.$attrs.editMode){
            this.getPharmacyLocation();
        }
    },


    created(){
        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges |= e.Changed
        }.bind(this));
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    beforeDestroy () {
        EventBus.$off("onChanged");
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },

    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                            title: this.$t('Msg.Confirm'),
                            okTitle: this.$t('Shared.BtnSave'),
                            cancelTitle: this.$t('Shared.BtnDismiss'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning'
                        })
                        .then(async value => {
                            if(!value){
                                next();
                            } else {
                                await this.ClickOffRoute();
                                var f = this.WasSaved;             
                                if(f){
                                    next();
                                }
                            }
                        })		
        } else {
            next()
        }
    },
}
</script>